import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../utils/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { useParams } from "react-router-dom";
import { CONFIG } from "../config";
import { useSidebar } from "../components/SidebarContext";
import { SidebarProvider } from "../components/SidebarContext";
import Loading from '../components/loading/Loading';
import NavbarLog from '../components/NavbarLog';
import Sidebar from '../components/Sidebar';
import SidebarToggle from '../components/SidebarToggle';
import Footer from '../components/Footer';
import "../css/ProfileSettings.css";

axios.defaults.withCredentials = true;  

function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let c of cookies) {
      const cookie = c.trim();
      if (cookie.startsWith(name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

const ProfileSettings = () => {
  const navigate = useNavigate ();
  const [profile, setProfile] = useState({ 
                                          email: '', 
                                          first_name:'', 
                                          last_name:'', 
                                          phone:'',
                                          address:'',
                                          city:'',
                                          province:'',
                                          zipcode:'',
                                          available_balance: 0,
                                        });
  const [loading, setLoading] = useState(true);
  const { user, isAuthenticated } = useAuth();
  const [profilePicture, setProfilePicture] = useState(null);
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(); 
  const [consoleError, setConsoleError] = useState("");
  const location = useLocation ();
  const [passForm, setPassForm] = useState(false)
  const [setlang, setLang] = useState("fa")
  const { lang } = useParams();
  const API_BASE = CONFIG.API_URL


  useEffect (() => {
    if (!loading) {
      if (!isAuthenticated) {
        navigate (`/${lang}/login`, { state: { from: location }, replace: true });
      }
    }
  }, [isAuthenticated, location, navigate]);


  useEffect(() => {
    axios.get(`${API_BASE}/api/me/`)
      .then(res => {
        setProfile(res.data);
        setSelectedCountry(res.data.country);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    fetch("/data/Regions.json")
      .then((res) => res.json())
      .then((data) => setCountries(data.regions))
      .catch((err) => setConsoleError("Error loading content:", err));
  },[]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "country") {
      setSelectedCountry(value);
    } else {
      setProfile(prev => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleImageChange = (e) => {
    if (e.target.files.length > 0) {
      setProfilePicture(e.target.files[0]); 
    }
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const csrfToken = getCookie("csrftoken");
      const formDataToSend = new FormData();
      
      for (const [key, value] of Object.entries(profile)) {
        if (
          value !== null &&
          value !== undefined &&
          key !== "profile_picture" &&     
          key !== "profile_picture_url"    
        ) {
          formDataToSend.append(key, value);
        }
      }
      
      formDataToSend.append("country", selectedCountry);
      
      if (profilePicture instanceof File) {
        formDataToSend.append("profile_picture", profilePicture);
      }
      
      await axios.put(`${API_BASE}/api/me/`, formDataToSend, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
        withCredentials: true,
      });
      alert(setlang === "en" ? "✓ Profile updated successfully" : "✓ حساب کاربری با موفقیت به‌روزرسانی شد");
      navigate(`/${lang}/profile`)
      
    } catch (err) {
      alert(setlang === "en" ? "Error updating profile, please login again":"خطایی رخ داد، لطفا دوباره وارد شو.");
    }
  };
  
  const handleDeleteAccount = async (name) => {
    if (!window.confirm (setlang === "en" ? "Would you like to remove your BidZone account permanenetly?" : "میخوای حساب کاربریت رو برای همیشه حذف کنی؟")) return ;
    navigate(`/${lang}/bye/${name}`)
  }
  
  // Handle Password Reset
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errMessage, setErrMessage] = useState("");
  const [sucMessage, setSucMessage] = useState("");

  const handleChangePassword = (e) => {
    setPassForm(true)
  };

  const handlePassReset = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      setErrMessage(setlang==="en"?"Passwords do not match":"تکرار کلمه عبور اشتباه است");
      return;
    }

    try {
      const csrfToken = getCookie("csrftoken");
      const response = await axios.post(
       `${API_BASE}/api/password-reset/`,
        {
          current_password: currentPassword,
          new_password: newPassword,
        },
        {
          headers: {
            "X-CSRFToken": csrfToken,
          },
          withCredentials: true,
        }
      );
      setSucMessage(setlang==="en"?"Password changed successfully":"کلمه عبور با موفقیت تغییر کرد");
      setErrMessage("");
    } catch (error) {
      setSucMessage("");
      setErrMessage(setlang==="en"?"Failed to change password":"اشتباهی رخ داد");
    }
  };

  
  useEffect (() => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if(lang !== "fa" && lang !== "en") {
      if ( userTimezone === "Asia/Tehran") {
        setLang(`fa`);
      } else {
        setLang(`en`);
      }
    } else {
      setLang(lang)
    }
  }, [lang])


  if (loading) return <Loading />;  

  return (
    <>
      <NavbarLog />
      <SidebarProvider>
      <div className={setlang==="en"?'PScenter-wrapper-en':'PScenter-wrapper-fa'}>
      {setlang==="en" && 
          <Sidebar />
        }
          <SidebarToggle />
        <div className="container">

        <div className='PScontainer'>
            <form className='PSform' onSubmit={handleSubmit}>
              {setlang === "en" ? 
                <h2>Account information</h2> : <h2>پروفایل کاربری</h2>
                }
              <input
                name="first_name"
                value={profile.first_name}
                onChange={handleChange}
                placeholder={setlang === "en" ? "New Name" : "تغییر نام"}
              />
              <input
                name="last_name"
                value={profile.last_name}
                onChange={handleChange}
                placeholder={setlang === "en" ? "New Last Name" : "تغییر نام خانوادگی"}
              />
              <input
                name="email"
                value={profile.email}
                onChange={handleChange}
                placeholder={setlang === "en" ? "New E-mail" : "تغییر ایمیل"}
              />
              {setlang === "en" ? <h2>Delivery information</h2> : <h2>آدرس پستی</h2>}
              <input
                name="address"
                value={profile.address}
                onChange={handleChange}
                placeholder={setlang === "en" ? "New Address" : "به روزرسانی آدرس"}
              />              
              <input
              name="city"
              value={profile.city}
              onChange={handleChange}
              placeholder={setlang === "en" ? "City" : "نام منطقه"}
              />
              <input
                name="province"
                value={profile.province}
                onChange={handleChange}
                placeholder={setlang === "en" ? "Province" : "نام استان"}
              />

              <select 
              name="country" 
              className='country-select' 
              value={selectedCountry?? ""} 
              onChange={(e) => setSelectedCountry(e.target.value)}>
                {setlang === "en" ? <option value="">-- Select Country --</option> : <option value="">-- کشور --</option>}
                {countries.map((cnty, idx) => (
                  <option key={idx} value={cnty}>
                    {cnty}
                  </option>
                ))}
              </select>

              <input
                name="zipcode"
                value={profile.zipcode}
                onChange={handleChange}
                placeholder={setlang === "en" ? "Zipcode" : "کد پستی"}
              />
              <input
                name="phone"
                value={profile.phone}
                onChange={handleChange}
                placeholder={setlang === "en" ? "New Phone No." : "شماره تماس"}
              />

              <input type="file" 
              accept="image/*" 
              onChange={handleImageChange} 
              placeholder={setlang === "en" ? "Change Profile Image" : "عکس پروفایلی"}
              />
              {setlang === "en" ?
              <button className='PSbtn-submit' type="submit">Update</button>:
              <button className='PSbtn-submit' type="submit">به روزرسانی</button>}
            </form>
          </div>

          <div className='PScontainer'>
            <button className='psw-account' onClick={()=>handleChangePassword()}>
              {setlang==="en"?"Reset Password":"کلمه ورود جدید"}
            </button>

            {passForm && (
              <form className='PSform' onSubmit={handlePassReset}>
                <input
                  type="password"
                  placeholder={setlang==="en"?"Current Password":"کلمه عبور فعلی"}
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                />

                <input
                  type="password"
                  placeholder={setlang==="en"?"New Password":"کلمه عبور جدید"}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />

                <input
                  type="password"
                  placeholder={setlang==="en"?"Confirm New Password":"تکرار کلمه عبور جدید"}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />

                <button type="submit" className='PSbtn-submit'>
                  {setlang===""?"Change Password":"تغییر کلمه عبور"}
                </button>

                {errMessage && <p className='PSform-err'>{errMessage}</p>}
                {sucMessage && <p className='PSform-suc'>{sucMessage}</p>}
              </form>
            )}
          </div>

          <div className='PScontainer'>
            <button className='delete-account' onClick={()=>handleDeleteAccount(profile.first_name)}>
              {setlang==="en"?"Remove my BidZone account":"حذف حساب کاربری"}
            </button>
          </div>
       </div>
        {setlang==="fa" && 
          <Sidebar />
        }
      </div>
      </SidebarProvider>
      <Footer />
    </>
  );
};

export default ProfileSettings;